import React, { useEffect, useState } from "react";
import Modal from "antd/lib/modal/Modal";
import AthenaOperations from "../../aws/gql/AthenaOperations";
import { Card, Col, Row, Input, Select } from "antd";
import { getSubjectByName } from "../../constants/AppConstants";
import { getCourse } from "../../constants/courses";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import { Option } from "antd/lib/mentions";
import { reportReasons } from "./data";
import { reportQuestion } from "../../analytics";

import IntlMessages from "../../util/IntlMessages";

// eslint-disable-next-line react/prop-types
const ReportQuestion = ({
  title = "Report Question",
  okText = "Report",
  showReportModal,
  question_id,
  parentStateHook,
  onSelection,
}) => {
  const [selectedReason, setSelectedReason] = useState(null);
  const [comment, setComment] = useState("");
  const onOk = () => {
    onSelection && onSelection();
    reportQuestion(question_id, selectedReason, comment);
    
    // setTimeout(() => {
        parentStateHook(false);
    // }, 1000);
  };
  const onCancel = () => {
    parentStateHook(false);
  };
  const onChange = (value) => {
    setSelectedReason(value);
  };
  return (
    <Modal
      title={title}
      centered
      visible={showReportModal}
      onOk={() => onOk()}
      onCancel={() => onCancel()}
      okButtonProps={{ disabled: !selectedReason }}
      okText={okText}
      maskClosable = {false}
      // cancelButtonProps={{ visible: true }}
      // footer={true}

      bodyStyle={{
        // background:subject_color,
        maxHeight: 400,
        overflowY: "scroll",
        overflowWrap: "break-word",
      }}
    >
      {/* <Row> */}
      <Form>
        <FormItem>
          <Select
            //   mode="multiple"
            showSearch
            style={{ width: "auto" }}
            placeholder="Select report reason"
            //   optionFilterProp="children"
            onChange={onChange}
            //   onFocus={onFocus}
            //   onBlur={onBlur}
            //   onSearch={onSearch}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {reportReasons.map((reason) => (
              <Option value={reason.key} key={reason.key}>
                {reason.value}
              </Option>
            ))}
          </Select>
        </FormItem>
        {selectedReason && <FormItem>
          <Input.TextArea
            placeholder="additional comments"
            onChange={(event) => {
              setComment(event.target.value);
            }}
          ></Input.TextArea>
        </FormItem>}
      </Form>
      {/* </Row> */}
    </Modal>
  );
};

export default ReportQuestion;
